var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline-primary text-center",on:{"click":function($event){return _vm.click(_vm.data)}}},[_c('i',{staticClass:"fa fa-crosshairs p-0"})])
}
var staticRenderFns = []

export { render, staticRenderFns }